var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-search w-100"},[_c('user-search-dropdown',{attrs:{"placeholder":"Quick Search Clients and Caregivers","role":_vm.role,"excludeManagers":"1"},on:{"selectUser":_vm.openProfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }